<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Table from '@/Components/Table/Table.vue'
import { useFormatTime } from '@/Composables/useFormatTime'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faStickyNote, faUndoAlt } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
import Icon from '@/Components/Utils/Icon.vue'
import { inject } from 'vue'
import { layoutStructure } from '@/Composables/useLayoutStructure'
import { aikuLocaleStructure } from '@/Composables/useLocaleStructure'
import Tag from '@/Components/Utils/Tag.vue'
import IconManufacture from '@/Components/Utils/IconManufacture.vue'
library.add(faStickyNote, faUndoAlt)


const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    data: {}
    role: string
}>()

const locale = inject('locale', aikuLocaleStructure)
const layout = inject('layout', layoutStructure)

const generateLinkManufacture = (slug: number) => {
    if (props.role === 'sales' || props.role === 'sales_special') {
        return route('sales.manufactures.show', slug)
    } else {
        return route('manufacture.show', slug)
    }
}

const generateLinkBrand = (slug?: string) => {
    if (!slug) return null
    
    switch (layout?.auth?.role) {
        case 'sales_special':
        case 'sales':
            return route('sales.brands.show', slug)
        default:
            return null
    }
}
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />
    
    <Table :resource="data">
        <!-- Column: Created_at -->
        <template #cell(created_at)="{ item }">
            <div class="whitespace-nowrap">
                {{ useFormatTime(item.created_at) }}
            </div>
        </template>

        <!-- Column: State_icon -->
        <template #cell(state_icon)="{ item }">
            <Icon :data="item.state_icon" />
        </template>

        <!-- Column: Product -->
        <!-- <template #cell(product)="{ item }">
        </template> -->

        <!-- Column: Reference -->
        <template #cell(reference)="{ item }">
            <div class="flex items-center gap-x-1 gap-y-1.5">
                <IconManufacture :data="item.state_icon" />
                <Link :href="generateLinkManufacture(item.slug)" class="primaryLink">
                    {{ item.reference }}
                </Link>
            </div>
            <div class="mt-1 ml-4">
                <Tag v-if="item.state === 'picked' && !item.validated_at" label="Belum validasi" :theme="7" noHoverColor />
            </div>
        </template>

        <!-- Column: Brand -->
        <template #cell(brand)="{ item }">
            <div>
                <div v-if="item.product">
                    <Icon :data="item.product?.type_icon" /> {{ item.product?.name }}
                </div>

                <div v-else class="text-gray-400 italic">
                    (Produk tidak ditemukan
                    <FontAwesomeIcon v-tooltip="'Produk mungkin telah dihapus dari sistem'" icon='fal fa-info-circle' class='' fixed-width aria-hidden='true' />)
                </div>

                <div v-if="item.brand">
                    <FontAwesomeIcon icon='fal fa-copyright' class='' fixed-width aria-hidden='true' />
                    <Link v-if="generateLinkBrand(item.brand_data?.slug)" :href="generateLinkBrand(item.brand_data?.slug)" class="secondaryLink font-medium">
                        {{ item.brand || '-' }}
                    </Link>
                    <span v-else>{{ item.brand || '-' }}</span>
                </div>
                <!-- <span v-if="item.customer" class="font-normal text-gray-400">({{ item.customer }})</span> -->
            </div>
        </template>
        
        <!-- Column: Note -->
        <template #cell(note)="{ item }">
            <div class="text-gray-400"><FontAwesomeIcon icon='fal fa-sticky-note' class='mr-1' fixed-width aria-hidden='true' />{{ item.note }}</div>
        </template>

        <!-- Column: Quantity -->
        <template #cell(quantity)="{ item }">
            <!-- dari order: {{ item.is_from_order ? item.quantity : 'cccc' }}
            cetak count: {{item.cetak_count}}
            finishing count: {{item.finishing_count}}
            validated count: {{item.validated_count}} -->
            <!-- <pre>{{ item }}</pre> -->

            <div>
                <div v-tooltip="'Kuantitas pesanan'">
                    <FontAwesomeIcon icon='fal fa-dot-circle' class='' fixed-width aria-hidden='true' />
                    {{ locale.number(item.quantity) }}
                </div>
                <div v-tooltip="'Kuantitas tercetak'">
                    <FontAwesomeIcon icon='fal fa-print' class='' fixed-width aria-hidden='true' />
                    {{ item.cetak_count === null ? '-' : locale.number(item.cetak_count) }}
                </div>
                <div v-tooltip="'Kuantitas finishing'">
                    <FontAwesomeIcon icon='fal fa-check' class='' fixed-width aria-hidden='true' />
                    {{ item.finishing_count === null ? '-' : locale.number(item.finishing_count) }}
                </div>
                <div v-tooltip="'Kuantitas validasi'">
                    <FontAwesomeIcon icon='fal fa-check-double' class='' fixed-width aria-hidden='true' />
                    {{ item.validated_count === null ? '-' : locale.number(item.validated_count) }}
                </div>

            </div>


            <!-- <div v-if="item.state === 'validated' || item.state === 'picked'">
                <div v-if="item.quantity === item.finishing_count">
                    {{ locale.number(item.quantity) }}
                    <FontAwesomeIcon icon='fal fa-check' class='text-green-500' v-tooltip="'Kuantitas sama'" fixed-width aria-hidden='true' />
                </div>
                <div v-else>
                    <span class="text-gray-400 line-through mr-1.5">{{ item.quantity }}</span>
                    <span class="inline-block">{{ locale.number(item.finishing_count) }}</span>
                    <FontAwesomeIcon icon='fal fa-check' class='text-green-500' v-tooltip="'Tervalidasi'" fixed-width aria-hidden='true' />
                </div>
            </div>

            <template v-else>
                {{ locale.number(item.quantity) }}
            </template> -->
        </template>
    </Table>
</template>